var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"wrapper",attrs:{"id":"loadsss"}},[_c('div',{staticClass:"loading"},_vm._l((_vm.texts),function(char,index){return _c('span',{key:index,style:({
        width: '2.2rem',
        animationDuration:
          _vm.duration.indexOf('s') === -1 ? _vm.duration + 's' : _vm.duration,
        animationDelay: (parseInt(_vm.duration) / _vm.text.length) * index + 's',
      })},[_vm._v(" "+_vm._s(char)+" ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }